import { FC } from "react";

import { Box, useMultiStyleConfig } from "@chakra-ui/react";

const StepDivider: FC<{ isVertical?: boolean }> = ({ isVertical = true }) => {
  const styles = useMultiStyleConfig("Steps", {});

  // using standart html to escape Chakra-UI forced styles that for some reason can't be overriden.
  return (
    <div style={{ width: "100%" }}>
      <Box sx={isVertical ? styles.divider : styles.flexDivider} />
    </div>
  );
};

export default StepDivider;
